import { render, staticRenderFns } from "./VisualizarDocumento.vue?vue&type=template&id=a9597f20"
import script from "./VisualizarDocumento.vue?vue&type=script&lang=js"
export * from "./VisualizarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports